import { Container } from 'components/layout/RibbonHeader/components';
import useURLs from 'hooks/use-url';

export default function RibbonHeader(): JSX.Element {
  const urls = useURLs();
  return (
    <Container className='ribbon-header'>
      <a target='_blank' rel='noopener noreferrer' href={urls?.goToMainSite?.url} aria-label={urls?.goToMainSite?.alt}>
        Go to main site
      </a>
    </Container>
  );
}
